import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LeafInputDirective } from 'app/@leaf/inputs/inputs/leaf-input.directive';
import { CashInputDirective } from 'app/core/directives/cash-input.directive';
import { MaxLengthDirective } from 'app/core/directives/input-max-length.directive';
import { ValidateFloatDirective } from 'app/core/directives/validate-float.directive';
import { DialogDismissComponent } from 'app/modules/sho_management_pro/common/components/dialog-dismiss/dialog-dismiss.component';
import { AlertService } from 'app/services/alert.service';
import { DialogService } from 'app/services/dialog.service';
import { FormsService } from 'app/services/forms.service';
import {
    KeyboardService,
    NumericKeydownOptions,
} from 'app/services/keyboard.service';
import { LoggerService } from 'app/services/logger.service';
import { UiService } from 'app/services/ui.service';
import { UtilsService } from 'app/services/utils.service';
import { Subject, take } from 'rxjs';
import { AnimatedTotalLabelComponent } from '../animated-total-label/animated-total-label.component';

const MatModules = [
    MatInputModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatLabel,
    MatIcon,
    MatDialogModule,
];
@Component({
    selector: 'app-testing',
    standalone: true,
    imports: [
        MatModules,
        ReactiveFormsModule,
        CommonModule,
        DialogDismissComponent,
        LeafInputDirective,
        MaxLengthDirective,
        CurrencyPipe,
        ValidateFloatDirective,
        AnimatedTotalLabelComponent,
        CashInputDirective,
    ],
    templateUrl: './testing.component.html',
    styleUrl: './testing.component.scss',
})
export class TestingComponent implements OnInit, OnDestroy {
    private unsubscribeAll: Subject<any> = new Subject<any>();
    private readonly _fb = inject(FormBuilder);

    // Header label and etc.
    categoryName = signal<string>('');
    parentEntity = signal<string>(null);

    locations = signal<any[]>([]);
    isEditing: boolean = false;

    /**
     * Form fields
     */
    formGroup = this._fb.group({
        testing: ['', Validators.required],
    });

    isOptional = false;

    isIcon: boolean = false;
    actionIconNames = ['plus'];

    constructor(
        private _dialogService: DialogService,
        private _alertService: AlertService,
        private logger: LoggerService,
        private _formsService: FormsService,
        private utils: UtilsService,
        private _uiService: UiService,
        private _keyboard: KeyboardService
    ) {}

    // --------------------------------------------------------------
    //  @ Lifecycle Hooks
    // --------------------------------------------------------------

    ngOnInit(): void {
        // Registering Icons
        this._uiService.registerSvgIcons(this.actionIconNames);
        this.isIcon = true;
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next(null);
        this.unsubscribeAll.complete();
    }

    // --------------------------------------------------------------
    //  @ Private Methods
    // --------------------------------------------------------------

    // --------------------------------------------------------------
    //  @ Public Methods
    // --------------------------------------------------------------

    onKeyDown(event: KeyboardEvent, options: NumericKeydownOptions = {}): void {
        this._keyboard.validateNumericKeydown(event, options);
    }

    onSubmit() {
        this._formsService.markFormGroupTouched(this.formGroup);

        // If the form is invalid do nothing
        if (this.formGroup.invalid) {
            return;
        }

        const formData = new FormData();

        // --------------------------------------------------------------
        // @ Main / Root Fields
        // --------------------------------------------------------------

        // this.utils.getFormDataValues(formData);
        // Convert formData to JSON
        const jsonFormData = this._formsService.getFormDataAsJson(formData);
        // console.log(jsonFormData);
    }

    loadDialog(): void {
        this._dialogService.openModalUpgrade(null).pipe(take(1)).subscribe();
    }
}
